import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_BA.json';
import exercises from './PILATES_EXERCISES_BA.json';
import recipes from './PILATES_RECIPES_BA.json';

export const PILATES_DATA_BA: ServiceData = {
  articles,
  exercises,
  recipes,
};
